import request from '@/utils/request';
import { IPost } from '@/types/post';

const PATH = '/post';

export const getPost = (uid: string) => request({
  url: `${PATH}/${uid}`,
  method: 'get',
});

export const viewPost = (uid: string) => request({
  url: `${PATH}/${uid}/view`,
  method: 'get',
});

export const getPostList = (listQuery: any) => request({
  url: `${PATH}/listPost`,
  method: 'get',
  params: {
    ...listQuery,
    page: listQuery.page - 1,
  },
});

export const addPost = (data: any) => request({
  url: PATH,
  method: 'post',
  data: {
    ...data,
  },
});

// 사업자 : 관리자 1:1 문의 목록
export const getListPost = (listQuery: any) => request({
  url: PATH,
  method: 'get',
  params: {
    ...listQuery,
    page: listQuery.page - 1,
  },
});

export const insertPost = (data: any) => request({
  url: `${PATH}/insert`,
  method: 'post',
  data: {
    ...data,
  },
});

export const updatePost = (uid: string, data: IPost) => request({
  url: `${PATH}/${uid}`,
  method: 'put',
  data: {
    ...data,
  },
});

export const deletePost = (uid: string) => request({
  url: `${PATH}/${uid}`,
  method: 'delete',
});
